export const query_getCurrencies = `
  query GetCurrencies { 
    getCurrencies {
      isoCode
      currency
      country
    }
  }`;
export const mutation_convertToEur = `
  mutation ConvertToEur(
    $isoCode: String!
    $amount: Float!
    $conversionDate: String!
  ) {
    convertToEur(
      isoCode: $isoCode
      amount: $amount
      conversionDate: $conversionDate
    ) {
      valutaId
      sourceCurrency
      sourceAmount
      targetCurrency
      convertedAmount
      conversionDate
      exchangeRate
      currencyName 
    }
  }`;
